export const getQueryParameter = (key: string): string => {
  if (typeof window === 'undefined') return undefined

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop: string) => searchParams.get(prop)
  })

  return params[key]
}
